import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";

export class CashManagementVerifyBalanceAction {
    constructor(public floatId: string) {
    }
}

/**
 * Action Service to verify a balance
 */
@Injectable()
export class CashManagementVerifyBalanceService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "cash-management-verify-balance");
    }
}
